import { action, observable } from 'mobx'
import { debounce } from 'lodash-es'

export default class ResponsiveStore {
  rootStore = null

  #breakpoints = { xxs: '', xs: '', sm: '', md: '', lg: '', xl: '', '2xl': '' } // eslint-disable-line sort-keys
  #breakpointsKeys = Object.keys(this.#breakpoints)

  @observable accessor isXxs = false
  @observable accessor isXs = false
  @observable accessor isSm = false
  @observable accessor isMd = false
  @observable accessor isLg = false
  @observable accessor isXl = false
  @observable accessor is2Xl = false

  constructor(rootStore) {
    this.rootStore = rootStore
    this.rootStore.registerDeconstructor(this.#_deconstructor)

    window.addEventListener(
      'load',
      () => {
        const doc = window.getComputedStyle(document.documentElement)
        this.#breakpointsKeys.forEach(x => {
          const value = doc.getPropertyValue(`--breakpoint-${x}`)
          this.#breakpoints[x] = `(min-width: ${value})`
          window.matchMedia(this.#breakpoints[x]).addEventListener('change', this.#updateDebounced)
        })

        this.#update()
      },
      { once: true, passive: true }
    )
  }

  #_deconstructor = () => {
    this.#breakpointsKeys.forEach(x => {
      window.matchMedia(this.#breakpoints[x]).removeEventListener('change', this.#updateDebounced)
    })
  }

  @action
  #update = () => {
    this.isXxs = window.matchMedia(this.#breakpoints.xxs).matches
    this.isXs = window.matchMedia(this.#breakpoints.xs).matches
    this.isSm = window.matchMedia(this.#breakpoints.sm).matches
    this.isMd = window.matchMedia(this.#breakpoints.md).matches
    this.isLg = window.matchMedia(this.#breakpoints.lg).matches
    this.isXl = window.matchMedia(this.#breakpoints.xl).matches
    this.is2Xl = window.matchMedia(this.#breakpoints['2xl']).matches
  }

  #updateDebounced = debounce(this.#update, 10)
}
